import Typography from '@mui/material/Typography';


export default function InfoSeqText() {
  
  return (
<div>
    
    <Typography variant="h6" >
    
How Were These Variants Identified?
<br /><br />  
To understand your genetic makeup, we first need to “read” your DNA. 
This is done through a process called genetic sequencing, 
which allows us to identify small differences in your DNA—called variants—that may be linked to certain health conditions.
<br /><br />  
Sequencing Platform
<br /><br />  
Your DNA was analyzed using Whole Genome Sequencing (WGS) on the Oxford Nanopore Technologies (ONT) platform, which is a long-read sequencing technology.
This advanced platform uses special flow cells containing an array of nanopores—tiny holes in an electro-resistant membrane. As your DNA passes through these nanopores, 
it creates small changes in electrical signals. 
These signals are then decoded in real time to reveal the sequence of your DNA. 
This method allows for a detailed and continuous read of long DNA strands, which helps us detect complex or previously missed variants more accurately.
<br /><br />  
What Happens After Sequencing?
Once your DNA is sequenced, we follow a multi-step process to identify and classify the variants:
<br /><br />  
DNA Alignment & Variant Calling
<br /><br />  
Your genetic sequence is compared to a standard human reference genome to spot any differences. 
These differences may be common or rare, and they are flagged for further analysis.
<br /><br />  
Variant Annotation & Classification
<br /><br />  
The identified variants are classified using evidence from trusted scientific databases,
including ClinVar, ClinGen, gnomAD, and HGMD. We also use bioinformatics tools and algorithms 
to help predict the potential impact of a variant if there is not enough existing evidence in the databases.
<br /><br />  
Sequencing results are highly accurate, but no test can offer a 100% certainty for predicting disease. Sometimes, further testing or family history may be needed to confirm findings.





Sequencing Platform:
<br /><br />  
WGS (Whole Genome Sequencing) was performed on the NANOPORE PromethION PLATFORM with long read sequencing.
<br /><br />
Oxford Nanopore Technologies (ONT) flow cells contain an array of nanopores embedded in an electro-resistant membrane. 
The DNA and RNA molecules are sequenced by passing them through the nanopores and rapidly analysing the generated electrical signals to provide real-time sequence information. 

<br /><br />
</Typography>    
</div>

   )
}